import { render } from "./EventVuex.vue?vue&type=template&id=4eb9f7ed&scoped=true"
import script from "./EventVuex.vue?vue&type=script&lang=js"
export * from "./EventVuex.vue?vue&type=script&lang=js"

import "./EventVuex.vue?vue&type=style&index=0&id=4eb9f7ed&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb9f7ed"]])

export default __exports__